module.exports = __webpack_public_path__ + "static/media/cloudy.c75c6f02.svg";